// API URL helper - Production'da kendi origin'ini kullan
export const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Preview ortamında değilsek, kendi origin'imizi kullan
    if (!hostname.includes('preview.emergentagent.com')) {
      return window.location.origin;
    }
  }
  // Development veya preview'da env'den al
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();
